import {
  compact, presence, set, symmetricDifference,
} from '@imcc/utilities';

export function toggleActiveReducer(state, action) {
  const { term, value } = action;
  const { active: activeFilters } = state.tabs[state.indexName];
  const oldValues = (activeFilters[term] as string[]) || [];
  const values = presence(symmetricDifference(oldValues, [value]));
  const newActiveFilters = compact({ ...activeFilters, [term]: values });

  return set(state, ['tabs', state.indexName, 'active'], newActiveFilters);
}
